'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dDashboard$002dAccount$002dStats from "./presto.types$-Dashboard-Account-Stats.js";
var $p;
/** @constructor */
function $c_Lpresto_types$DashboardAccountStats$() {
}
export { $c_Lpresto_types$DashboardAccountStats$ as $c_Lpresto_types$DashboardAccountStats$ };
$p = $c_Lpresto_types$DashboardAccountStats$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DashboardAccountStats$;
/** @constructor */
function $h_Lpresto_types$DashboardAccountStats$() {
}
export { $h_Lpresto_types$DashboardAccountStats$ as $h_Lpresto_types$DashboardAccountStats$ };
$h_Lpresto_types$DashboardAccountStats$.prototype = $p;
$p.l = (function() {
  return "DashboardAccountStats";
});
$p.cFO = (function(x$0) {
  return new $j_presto$002etypes$0024$002dDashboard$002dAccount$002dStats.$c_Lpresto_types$DashboardAccountStats($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$uJ(x$0.j(0)), x$0.j(1), (x$0.j(2) | 0));
});
var $d_Lpresto_types$DashboardAccountStats$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DashboardAccountStats$, "presto.types$DashboardAccountStats$", ({
  Zx: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_types$DashboardAccountStats$ as $d_Lpresto_types$DashboardAccountStats$ };
var $n_Lpresto_types$DashboardAccountStats$;
function $m_Lpresto_types$DashboardAccountStats$() {
  if ((!$n_Lpresto_types$DashboardAccountStats$)) {
    $n_Lpresto_types$DashboardAccountStats$ = new $c_Lpresto_types$DashboardAccountStats$();
  }
  return $n_Lpresto_types$DashboardAccountStats$;
}
export { $m_Lpresto_types$DashboardAccountStats$ as $m_Lpresto_types$DashboardAccountStats$ };
//# sourceMappingURL=presto.types$-Dashboard-Account-Stats$.js.map
